<script lang="ts">
	import {
		DROP_PAGE_ANCHOR_TRANSFORM,
		DROP_PAGE_TABS_ANCHOR_TRANSFORM,
	} from '$global/features/navigation/constants/sizing';

	interface Props {
		id: string;
		hasTabs: boolean;
		options?: Parameters<HTMLElement['scrollIntoView']>[0];
		delay?: number;
	}

	let { id, hasTabs, options, delay }: Props = $props();

	const scrollIntoView = (node: HTMLElement) => {
		if (window.location.href.endsWith(id)) {
			setTimeout(() => {
				node.scrollIntoView(options);
			}, delay || 0);
		}
	};
</script>

<span
	{...!delay ? { id: id.slice(1) } : { 'data-cy': id.slice(1) }}
	use:scrollIntoView
	class={`inline-block h-[0px] ${
		hasTabs ? DROP_PAGE_TABS_ANCHOR_TRANSFORM : DROP_PAGE_ANCHOR_TRANSFORM
	}`}>&nbsp;</span
>
